import ReactDOM from "react-dom";
import React, { useState } from "react";

import * as _ from "lodash";
import * as $ from "jquery";

import { Formik, Field, Form, ErrorMessage } from "formik";

import { UiUtils } from "../../common/uiUtils";
import { ViewerUtils } from "../../common/viewerUtils";
import { ModelApi } from "../../api/modelApi";
import { viewerOptions, viewerState } from "../../viewer";
import * as SmartDrawings from "../../smartDrawings";
import { CommentViewerUtils } from "./commentViewerUtils";
import { Misc } from "../../common/misc";

interface EditLabelProps {
    text: string;
    submit: (text: string) => void;
}

interface CommentListProps {
    comments: SmartDrawings.Comment[];
    selectedCommentId: string;
    addComment: () => void;
    removeComment: () => void;
    removeAllComments: () => void;
    selectComment: (id) => void;
}

interface CommentProps {
    comment: SmartDrawings.Comment;
    selected: boolean;
    onClick: () => void;
}

interface CommentUiProps {
    viewer: Autodesk.Viewing.GuiViewer3D;
    selectedCommentId: string;
}

interface CommentUiState {
    comments: { [key: string]: SmartDrawings.Comment; };
    selectedCommentId: string;
}

const CommentField = (props) => {
    return <div className="form-group row">
               <label className="col-formlabel col-sm-3">{props.label}</label>
               <div className="col">
                   <Field type={props.type} component={props.component} name={props.name} className="form-control" rows={props.rows}/>
                   <ErrorMessage name={props.name} component="div"/>
               </div>
           </div>;
}

const EditForm: React.SFC<EditLabelProps> = (props) => {
    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                text: props.text
            }}
            onSubmit={(values, actions) => {
                actions.setSubmitting(false);
                props.submit(values.text);
            }}
            validate={(values: any) => {
                const errors: any = {};

                if (!values.text) {
                    errors.text = "Required";
                }

                return errors;
            }}
            render={({ values, errors, status, touched, isSubmitting, handleReset, setValues }) => (
                <Form className="container pt-3" style={{ width: "auto" }}>

                    <CommentField type="text" name="text" label="Comment *" component="textarea" rows={5}/>

                    <div className="form-group row">
                        <div className="col">
                            <span>* Required fields</span>
                        </div>
                    </div>

                    <div className="form-group row">
                        <div className="col">
                            <span>Set comment position by clicking on the model</span>
                        </div>
                    </div>

                    <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
                        Update
                    </button>
                </Form>
            )}/>
    );
}

const CommentRow: React.SFC<CommentProps> = props => {

    return <li className="comment-list-item" style={props.selected ? { border: "solid white" } : null} onClick={props.onClick}>
               <div className="comment-list-label">{props.comment.text}</div>
           </li>;

}

const CommentList: React.SFC<CommentListProps> = (props) => {
    return <div>
               <ul className="plain-list" style={{ height: "150px", overflow: "hidden", overflowY: "scroll" }}>
                   {props.comments.map(c => {
                       return <CommentRow
                                  key={c.id}
                                  comment={c}
                                  selected={c.id === props.selectedCommentId}
                                  onClick={() => props.selectComment(c.id)}/>;
                   })}
               </ul>
               <button className="btn btn-primary" onClick={() => props.addComment()}>
                   Add
               </button>
        <button className="btn btn-primary ml-1" onClick={props.removeComment} disabled={props.selectedCommentId === null}>
                   Remove
               </button>
        <button className="btn btn-primary ml-1" onClick={props.removeAllComments} disabled={_.isEmpty(props.comments)}>
                   Remove all
               </button>
           </div>;
}

class CommentUi extends React.Component<CommentUiProps, CommentUiState> {

    private commentViewerUtils: CommentViewerUtils;

    constructor(props) {
        super(props);
        this.state = {
            comments: {},
            selectedCommentId: props.selectedCommentId
        }
        this.commentViewerUtils = new CommentViewerUtils(props.viewer, this.onClickViewer, this.onClickMarker);
    }

    componentDidMount(): void {
        this.commentViewerUtils.activate();
        this.removeAllComments();
        for (let cid of _.keys(viewerState.comments)) {
            const comment = viewerState.comments[cid];
            this.commentViewerUtils.addCommentMarker(cid,
                new THREE.Vector3(comment.position.x, comment.position.y, comment.position.z).toViewerUnits(),
                comment.text);
        }
        if (!_.isEmpty(viewerState.comments)) {
            this.setState({ comments: viewerState.comments });
            this.selectComment(this.props.selectedCommentId || _.first(_.values(viewerState.comments)).id);
        };
    }

    componentWillUnmount(): void {
        this.commentViewerUtils.deactivate();
        this.selectComment(null);
    }

    componentDidUpdate(prevProps: {readonly [P in "viewer"]: CommentUiProps[P]},
        prevState: {readonly [P in "comments" | "selectedCommentId"]: CommentUiState[P]},
        snapshot?): void {
        viewerState.comments = this.state.comments;
    }

    onClickViewer = (pos: THREE.Vector3) => {
        if (this.state.selectedCommentId != null) {
            const comment = this.state.comments[this.state.selectedCommentId];
            this.commentViewerUtils.updateCommentMarker(this.state.selectedCommentId, pos, comment.text, true);
            this.updateComment(null, pos);
        } else {
            this.addComment(pos);
        }
    }

    onClickMarker = (id) => {
        (this.props.viewer.getExtension("NewCommentExtension") as any).showComments(id);

        this.selectComment(id);
    }

    selectComment = (id) => {
        const oldSelected = $(".comment-label-selected");
        oldSelected.removeClass("comment-label-selected");
      
        this.setState({ selectedCommentId: id });
        if (id != null) {
            const selected = $(`#${id}`);
            selected.addClass("comment-label-selected");
        }
    }

    addComment = (pos: THREE.Vector3 = new THREE.Vector3(0, 0, 0)) => {
        const id = Misc.guid();
        const updatedComments = { ...this.state.comments };
        updatedComments[id] = { id: id, text: "New comment", position: pos.toModelUnits() };
        this.setState({ comments: updatedComments });
        this.commentViewerUtils.addCommentMarker(id, pos, "New Comment", true);
        this.selectComment(id);
    }

    removeComment = () => {
        const updatedComments = { ...this.state.comments };
        delete updatedComments[this.state.selectedCommentId];
        this.commentViewerUtils.removeCommentMarker(this.state.selectedCommentId);
        this.setState({ comments: updatedComments, selectedCommentId: null });
    }

    removeAllComments = () => {
        this.commentViewerUtils.removeAllCommentMarkers();
        this.setState({ comments: {} });
    }

    updateComment = (text, position: THREE.Vector3) => {
        const selectedId = this.state.selectedCommentId;
        const updatedComments = { ...this.state.comments };
        const comment = updatedComments[selectedId];
        comment.text = text || comment.text;
        comment.position = position?.toModelUnits() || comment.position;
        updatedComments[selectedId] = comment;
        this.setState({ comments: updatedComments });
        this.commentViewerUtils.updateCommentMarker(this.state.selectedCommentId, comment.position.toViewerUnits(), comment.text, true);
    }

    render() {
        const comments = _.values(this.state.comments);
        const selectedComment = this.state.comments[this.state.selectedCommentId];
        return <div id="comment-react" className="react-content">
                   <CommentList comments={comments}
                                selectedCommentId={this.state.selectedCommentId}
                                addComment={this.addComment}
                removeComment={this.removeComment}
                removeAllComments={this.removeAllComments}
                                selectComment={this.selectComment}/>
                   {!_.isEmpty(this.state.comments) &&
                       <EditForm text={selectedComment != null ? selectedComment.text : ""} submit={text => this
                           .updateComment(text, null)}/> }
               </div>;
    }

}

class CommentPanel extends Autodesk.Viewing.UI.DockingPanel {

    private viewer: Autodesk.Viewing.GuiViewer3D;

    private contentDiv: HTMLDivElement;
    private reactNode;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, container: any, id: string) {
        super(container, id, "Comments");
        this.viewer = viewer;

        this.container.classList.add("comment-panel");

        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.container.appendChild(this.contentDiv);
    }

    setVisible(show: boolean, selectedCommentId?: string) {
        super.setVisible(show);
        if (show) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = ReactDOM.render(<CommentUi viewer={this.viewer} selectedCommentId={selectedCommentId} />, this.contentDiv);
        } else if (this.reactNode) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = null;
        }
    }
}

export { CommentUi, CommentPanel };